module.exports = __webpack_public_path__ + "static/media/projectsImage14.a71d9ebf.jpg";